// extracted by mini-css-extract-plugin
export default {"container":"bSsIe","hovered":"c1Ce9","text":"M1VvK","popup":"ljTHu"};